import React, { useReducer } from 'react';
import NotificationContext from './notificationContext';
import NotificationReducer from './notificationReducer';
import {
  SET_NOTIFICATION,
  REMOVE_NOTIFICATION,
  SET_OTP_NOTIFICATION,
  REMOVE_OTP_NOTIFICATION,
} from './types';

const NotificationState = (props) => {
  const initialState = { notification: null, otpNotification: null };

  const [state, dispatch] = useReducer(NotificationReducer, initialState);

  // Set Notification
  const setNotification = (msg, type) => {
    dispatch({
      type: SET_NOTIFICATION,
      payload: { msg, type },
    });

    setTimeout(() => dispatch({ type: REMOVE_NOTIFICATION }), 5000);
  };
  const setOtpNotification = (msg, type) => {
    dispatch({
      type: SET_OTP_NOTIFICATION,
      payload: { msg, type },
    });

    setTimeout(() => dispatch({ type: REMOVE_OTP_NOTIFICATION }), 5000);
  };

  return (
    <NotificationContext.Provider
      value={{
        notification: state,
        otpNotification: state,
        setNotification,
        setOtpNotification,
      }}
    >
      {props.children}
    </NotificationContext.Provider>
  );
};

export default NotificationState;
